import { addLightness, addSaturation } from '../../../colorMutators/colorMutators/index.js';

const AccentsLightInputs = {
    primary: {
        base: {
            default: '#C209C1',
            action: '',
            active: '',
            activeAction: '',
        },
        text: {
            default: '#ffffff',
            action: '',
            active: '',
            activeAction: '',
        },
    },
    secondary: {
        base: {
            default: '#5A00EE',
            action: '',
            active: '',
            activeAction: '',
        },
        text: {
            default: '#ffffff',
            action: '',
            active: '',
            activeAction: '',
        },
    },
    tertiary: {
        base: {
            default: '#f2f2f2',
            action: '#B4B4B4',
            active: '#f2f2f2',
            activeAction: '#B4B4B4',
        },
        text: {
            default: '#000000',
            action: '',
            active: '',
            activeAction: '',
        },
    },
};
const AccentsDarkInputs = {
    primary: {
        base: {
            default: '#E859B4',
            action: '#9E3D7A',
            active: '#E859B4',
            activeAction: '#9E3D7A',
        },
        text: {
            default: '#000000',
            action: '',
            active: '',
            activeAction: '',
        },
    },
    secondary: {
        base: {
            default: '#BD99F8',
            action: '#8168A9',
            active: '#BD99F8',
            activeAction: '#8168A9',
        },
        text: {
            default: '#000000',
            action: '',
            active: '',
            activeAction: '',
        },
    },
    tertiary: {
        base: {
            default: '#2F2F2F',
            action: '#080808',
            active: '#2F2F2F',
            activeAction: '#080808',
        },
        text: {
            default: '#ffffff',
            action: '',
            active: '',
            activeAction: '',
        },
    },
};
const AccentsLightValues = Object.freeze({
    primary: {
        base: {
            default: AccentsLightInputs.primary.base.default,
            action: AccentsLightInputs.primary.base.action || addLightness(AccentsLightInputs.primary.base.default, -10),
            active: AccentsLightInputs.primary.base.active || AccentsLightInputs.primary.base.default,
            activeAction: AccentsLightInputs.primary.base.activeAction || addLightness(AccentsLightInputs.primary.base.default, -10),
        },
        text: {
            default: AccentsLightInputs.primary.text.default,
            action: AccentsLightInputs.primary.text.action || AccentsLightInputs.primary.text.default,
            active: AccentsLightInputs.primary.text.active || AccentsLightInputs.primary.text.default,
            activeAction: AccentsLightInputs.primary.text.activeAction || AccentsLightInputs.primary.text.default,
        },
    },
    secondary: {
        base: {
            default: AccentsLightInputs.secondary.base.default,
            action: AccentsLightInputs.secondary.base.action || addLightness(AccentsLightInputs.secondary.base.default, -15),
            active: AccentsLightInputs.secondary.base.active || AccentsLightInputs.secondary.base.default,
            activeAction: AccentsLightInputs.secondary.base.activeAction || addLightness(AccentsLightInputs.secondary.base.default, -15),
        },
        text: {
            default: AccentsLightInputs.secondary.text.default,
            action: AccentsLightInputs.secondary.text.action || AccentsLightInputs.secondary.text.default,
            active: AccentsLightInputs.secondary.text.active || AccentsLightInputs.secondary.text.default,
            activeAction: AccentsLightInputs.secondary.text.activeAction || AccentsLightInputs.secondary.text.default,
        },
    },
    tertiary: {
        base: {
            default: AccentsLightInputs.tertiary.base.default,
            action: AccentsLightInputs.tertiary.base.action || addLightness(AccentsLightInputs.tertiary.base.default, -10),
            active: AccentsLightInputs.tertiary.base.active || AccentsLightInputs.tertiary.base.default,
            activeAction: AccentsLightInputs.tertiary.base.activeAction || addLightness(AccentsLightInputs.tertiary.base.default, -10),
        },
        text: {
            default: AccentsLightInputs.tertiary.text.default,
            action: AccentsLightInputs.tertiary.text.action || AccentsLightInputs.tertiary.text.default,
            active: AccentsLightInputs.tertiary.text.active || AccentsLightInputs.tertiary.text.default,
            activeAction: AccentsLightInputs.tertiary.text.activeAction || AccentsLightInputs.tertiary.text.default,
        },
    },
});
const AccentsDarkValues = Object.freeze({
    primary: {
        base: {
            default: AccentsDarkInputs.primary.base.default,
            action: AccentsDarkInputs.primary.base.action || addLightness(AccentsDarkInputs.primary.base.default, -10),
            active: AccentsDarkInputs.primary.base.active || AccentsDarkInputs.primary.base.default,
            activeAction: AccentsDarkInputs.primary.base.activeAction || addLightness(AccentsDarkInputs.primary.base.default, -10),
        },
        text: {
            default: AccentsDarkInputs.primary.text.default,
            action: AccentsDarkInputs.primary.text.action || AccentsDarkInputs.primary.text.default,
            active: AccentsDarkInputs.primary.text.active || AccentsDarkInputs.primary.text.default,
            activeAction: AccentsDarkInputs.primary.text.activeAction || AccentsDarkInputs.primary.text.default,
        },
    },
    secondary: {
        base: {
            default: AccentsDarkInputs.secondary.base.default,
            action: AccentsDarkInputs.secondary.base.action || addLightness(AccentsDarkInputs.secondary.base.action, -15),
            active: AccentsDarkInputs.secondary.base.active || AccentsDarkInputs.secondary.base.default,
            activeAction: AccentsDarkInputs.secondary.base.activeAction || addLightness(AccentsDarkInputs.secondary.base.default, -10),
        },
        text: {
            default: AccentsDarkInputs.secondary.text.default,
            action: AccentsDarkInputs.secondary.text.action || AccentsDarkInputs.secondary.text.default,
            active: AccentsDarkInputs.secondary.text.active || AccentsDarkInputs.secondary.text.default,
            activeAction: AccentsDarkInputs.secondary.text.activeAction || AccentsDarkInputs.secondary.text.default,
        },
    },
    tertiary: {
        base: {
            default: AccentsDarkInputs.tertiary.base.default,
            action: AccentsDarkInputs.tertiary.base.action || addLightness(AccentsDarkInputs.tertiary.base.default, -15),
            active: AccentsDarkInputs.tertiary.base.active || AccentsDarkInputs.tertiary.base.default,
            activeAction: AccentsDarkInputs.tertiary.base.activeAction || addLightness(AccentsDarkInputs.tertiary.base.default, -10),
        },
        text: {
            default: AccentsDarkInputs.tertiary.text.default,
            action: AccentsDarkInputs.tertiary.text.action || AccentsDarkInputs.tertiary.text.default,
            active: AccentsDarkInputs.tertiary.text.active || AccentsDarkInputs.tertiary.text.default,
            activeAction: AccentsDarkInputs.tertiary.text.activeAction || AccentsDarkInputs.tertiary.text.default,
        },
    },
});
const AccentsLightIllustrationsValues = Object.freeze({
    primary: {
        tint1: addLightness(AccentsLightInputs.primary.base.default, 10),
        tint2: addSaturation(addLightness(AccentsLightInputs.primary.base.default, 20), -10),
        tint3: addSaturation(addLightness(AccentsLightInputs.primary.base.default, 30), -15),
        tint4: addSaturation(addLightness(AccentsLightInputs.primary.base.default, 40), -20),
        tint5: addSaturation(addLightness(AccentsLightInputs.primary.base.default, 50), -25),
        tint6: addSaturation(addLightness(AccentsLightInputs.primary.base.default, 55), -30),
    },
    secondary: {
        tint1: addLightness(AccentsLightInputs.secondary.base.default, 5),
        tint2: addSaturation(addLightness(AccentsLightInputs.secondary.base.default, 10), -10),
        tint3: addSaturation(addLightness(AccentsLightInputs.secondary.base.default, 20), -15),
        tint4: addSaturation(addLightness(AccentsLightInputs.secondary.base.default, 30), -20),
        tint5: addSaturation(addLightness(AccentsLightInputs.secondary.base.default, 40), -25),
        tint6: addSaturation(addLightness(AccentsLightInputs.secondary.base.default, 45), -30),
    },
});
const AccentsDarkIllustrationsValues = Object.freeze({
    primary: {
        tint1: addLightness(AccentsDarkInputs.primary.base.default, -5),
        tint2: addSaturation(addLightness(AccentsDarkInputs.primary.base.default, -10), -10),
        tint3: addSaturation(addLightness(AccentsDarkInputs.primary.base.default, -20), -15),
        tint4: addSaturation(addLightness(AccentsDarkInputs.primary.base.default, -30), -20),
        tint5: addSaturation(addLightness(AccentsDarkInputs.primary.base.default, -40), -25),
        tint6: addSaturation(addLightness(AccentsDarkInputs.primary.base.default, -45), -30),
    },
    secondary: {
        tint1: addLightness(AccentsDarkInputs.secondary.base.default, -5),
        tint2: addSaturation(addLightness(AccentsDarkInputs.secondary.base.default, -10), -10),
        tint3: addSaturation(addLightness(AccentsDarkInputs.secondary.base.default, -20), -15),
        tint4: addSaturation(addLightness(AccentsDarkInputs.secondary.base.default, -30), -20),
        tint5: addSaturation(addLightness(AccentsDarkInputs.secondary.base.default, -40), -25),
        tint6: addSaturation(addLightness(AccentsDarkInputs.secondary.base.default, -45), -30),
    },
});

export { AccentsDarkIllustrationsValues, AccentsDarkInputs, AccentsDarkValues, AccentsLightIllustrationsValues, AccentsLightInputs, AccentsLightValues };
